import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-user",
  "use": "icon-user-usage",
  "viewBox": "0 0 12 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 10\" id=\"icon-user\"><title>user</title><path d=\"M6,0A5.9,5.9,0,0,0,0,5.8,5.69,5.69,0,0,0,1.86,10,4.6,4.6,0,0,1,6,7.48,4.6,4.6,0,0,1,10.14,10,5.69,5.69,0,0,0,12,5.8,5.9,5.9,0,0,0,6,0ZM6,6.81A2.38,2.38,0,0,1,3.58,4.47,2.38,2.38,0,0,1,6,2.13,2.38,2.38,0,0,1,8.42,4.47,2.38,2.38,0,0,1,6,6.81Z\" fill=\"#6b7685\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/user.svg
// module id = 184
// module chunks = 0 1 2